import * as Yup from "yup";

export interface DashboardFormAlertsFields {
  alerts_show_section: boolean;
  alerts_for_all_checks: boolean;
  alerts_include_ignored: boolean;
  alerts_include_resolved: boolean;
  alerts_num_to_show: number;
}

export const DashboardFormAlertsSchema = Yup.object({
  alerts_show_section: Yup.boolean().required(),
  alerts_for_all_checks: Yup.boolean().required(),
  alerts_include_ignored: Yup.boolean().required(),
  alerts_include_resolved: Yup.boolean().required(),
  alerts_num_to_show: Yup.number().required(),
});

export const DashboardFormAlertsDefaults = {
  alerts_show_section: true,
  alerts_for_all_checks: true,
  alerts_include_ignored: true,
  alerts_include_resolved: true,
  alerts_num_to_show: 5,
};
